import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { Module } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    portfolio: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var _props$portfolio$vent, _props$portfolio$vent2;
    var props = __props;
    var showIndividualMetrics = ref(false);
    var ventures = ((_props$portfolio$vent = props.portfolio.ventureLinks) === null || _props$portfolio$vent === void 0 ? void 0 : (_props$portfolio$vent2 = _props$portfolio$vent.filter(function (ventureLink) {
      return ventureLink.modules.includes(Module.Metrics);
    })) === null || _props$portfolio$vent2 === void 0 ? void 0 : _props$portfolio$vent2.map(function (link) {
      return link.venture;
    })) || [];
    var ventureIds = ventures.map(function (venture) {
      return venture === null || venture === void 0 ? void 0 : venture.id;
    });
    return {
      __sfc: true,
      props: props,
      showIndividualMetrics: showIndividualMetrics,
      ventures: ventures,
      ventureIds: ventureIds
    };
  }
});